import { all, call, put, takeLatest } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { setPriceInfo } from 'Store/AssetManagement/PriceInfo/PriceInfoAction';
import { GET_PRICE_INFO } from 'Store/AssetManagement/PriceInfo/PriceInfoType';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getPriceInfo(request: any): any {

    let payloadData : IPayload= {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/vehicle/getpriceinfo`,
        payload: request.data
    }

    try {
        yield put(globalLoaderText("Fetching price information...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setPriceInfo(response))
        yield put(globalLoaderText(""));
    } catch (error) {        
        yield put(setPriceInfo(0))
        yield put(globalLoaderText(""));
    }
}

function* watchGetDriveTrain() {
    yield takeLatest(GET_PRICE_INFO, getPriceInfo)
}

export default function* combinedSaga() {
    yield all([
        watchGetDriveTrain()
    ])
}
